export default "__VITE_ASSET__4Erl$GVd__"